import TimeType from "../models/TimeType";
import {useSetRecoilState} from "recoil";
import {userKakaoScopeState} from "../states/user/userAtom";
import {getUserKakaoScope} from "../api/AlfyApiClient";
import {OAUTH_CALLBACK_URL} from "../constants/constants";
import {getShortenDateWithDayOfWeek} from "../utils/Utils";
import {PollItem} from "../models/PollItem";
import {Appointment} from "../models/Appointment";
import {UI_BASE_URL} from "../api/ApiClientConfig";

export const useKakao = () => {
    const kakao = (window as any).Kakao;
    const setUserKakaoScope = useSetRecoilState(userKakaoScopeState);
    const kakaoLogin = (payload: string | null) => {
        const options = {
            redirectUri: OAUTH_CALLBACK_URL,
            scope: "profile_nickname,profile_image,account_email",
            ...(payload && { state: payload })
        };

        kakao.Auth.authorize(options);
    };

    /**
     * 유저의 카카오 동의 항목들을 가져오는 함수
     * 메시지 보내기에 사용하려 했는데 공유쪽으로 틀면서 쓸모 없어짐.
     * 나중에 쓸 일 있을지 모르니 남겨둔다.
     */
    const fetchKakaoScopes = async () => {
        try {
            const kakaoScopes = await getUserKakaoScope();
            setUserKakaoScope(kakaoScopes.scopes);
        } catch (error) {
            console.error('Failed to fetch kakao scopes', error);
            throw error
        }
    }

    const askAttendance = (targetMemberName: string, pollItem: PollItem) => {
        const selectedDate = pollItem.date;
        const appointmentTimeType = pollItem.timeType;

        const month = selectedDate.getMonth() + 1;
        const day = selectedDate.getDate();
        const timeTypeString = TimeType.getTimeTypeStringForTag(appointmentTimeType)

        kakao.Share.sendDefault({
            objectType: 'feed',
            content: {
                title: `${targetMemberName}님, ${month}월 ${day}일 ${timeTypeString}에 시간 되세요?`,
                description: '아래 버튼을 눌러 약속 참여 여부를 알려주세요.',
                imageUrl: 'https://placehold.co/600x600', // TODO 제대로
                link: {
                    webUrl: `${UI_BASE_URL}/appointments/${pollItem.appointmentId}?askAttendanceId=${pollItem.id}`,
                    mobileWebUrl: `${UI_BASE_URL}/appointments/${pollItem.appointmentId}?askAttendanceId=${pollItem.id}`,
                },
            },
            buttons: [
                {
                    title: '응답하기',
                    link: {
                        webUrl: `${UI_BASE_URL}/appointments/${pollItem.appointmentId}?askAttendanceId=${pollItem.id}`,
                        mobileWebUrl: `${UI_BASE_URL}/appointments/${pollItem.appointmentId}?askAttendanceId=${pollItem.id}`,
                    },
                },
            ],
        })
    }

    const inviteByKakao = (appointment: Appointment) => {
        const organizerMemberName = appointment.members.find(member => member.role === 'ORGANIZER')?.name
        const shareTitle = organizerMemberName ? `${organizerMemberName}님과 약속을 잡아볼까요?` : '약속을 잡아볼까요?'
        const shareDescription = `${getShortenDateWithDayOfWeek(appointment.getPollDateFirstDate())} 부터 ${getShortenDateWithDayOfWeek(appointment.getPollDateLastDate())} 사이로 잡아봐요`
        kakao.Share.sendDefault({
            objectType: 'feed',
            content: {
                title: shareTitle,
                description: shareDescription,
                imageUrl: 'https://placehold.co/600x600', // TODO 제대로
                link: {
                    webUrl: `${UI_BASE_URL}/appointments/${appointment.id}`,
                    mobileWebUrl: `${UI_BASE_URL}/appointments/${appointment.id}`,
                },
            },
            buttons: [
                {
                    title: '응답하기',
                    link: {
                        webUrl: `${UI_BASE_URL}/appointments/${appointment.id}`,
                        mobileWebUrl: `${UI_BASE_URL}/appointments/${appointment.id}`,
                    },
                },
            ],
        })
    }

    return {
        kakaoLogin,
        askAttendance,
        inviteByKakao,
        fetchKakaoScopes,
    }
}